import { apiFetcher } from '../api-fetcher';

export type GroupKey = 'A' | 'B' | 'C' | 'D' | 'E';

interface ExperimentGroupResponse {
  data: {
    experimentKey: string;
    experimentName: string;
    experimentVersion: number;
    experimentGroup: GroupKey;
  };
}

/**
 *
 * [스펙 문서] (https://quicket.atlassian.net/wiki/spaces/DEV/pages/3508081289/A+B+API#Response-Model.4)
 * [swagger](http://apidoc.bunjang.co.kr/swagger-ui/index.html?urls.primaryName=bun-abtest-api%20(A%2FB%20%ED%85%8C%EC%8A%A4%ED%8A%B8)#/A%2FB%20Test%20%ED%81%B4%EB%9D%BC%EC%9D%B4%EC%96%B8%ED%8A%B8%20%EB%9D%BC%EC%9D%B4%EB%B8%8C%EB%9F%AC%EB%A6%AC/encodeBase64)
 */
export const getExperimentGroup = async (params: {
  experimentKey: string;
  userId?: number;
  buid?: string;
  deviceType?: string;
  appVersion?: string;
}): Promise<ExperimentGroupResponse> => {
  return apiFetcher.get<ExperimentGroupResponse>(`/api/abtest/v1/experiment-group`, params);
};
